import { render, staticRenderFns } from "./ToggleSwitchMenu.vue?vue&type=template&id=43bbcdf7&"
import script from "./ToggleSwitchMenu.vue?vue&type=script&lang=js&"
export * from "./ToggleSwitchMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports